import { useCallback, useEffect, useState } from "react";

import { getTables } from "services/tables/rest";
import { TableDto } from "services/tables/restModels";

export interface UseTablesResult {
    tables: TableDto[];
    loading: boolean;
    error: boolean;
    setTables: (tables: TableDto[]) => void;
    refetch: () => void;
}

export const useTables = (): UseTablesResult => {
    const [tables, setTables] = useState<TableDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // ignore-флаг: ответ после размонтирования не трогает стейт.
        let ignore = false;

        setLoading(true);
        setError(false);

        getTables()
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setTables(result);
                } else {
                    setError(true);
                    setTables([]);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setTables([]);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [reloadKey]);

    return { tables, loading, error, setTables, refetch };
};
